import BasicLayout from '@/layout/BasicLayout.vue'

const extranetRouter = {
  path: '/extranet',
  component: BasicLayout,
  children: [
    {
      path: '/extranet/remote-diagnosis',
      component: () => import('../../views/extranet/extranet/index.vue')
    },
    {
      path: '/extranet/extranet-v2',
      component: () => import('../../views/extranet/v2/index.vue')
    },
    {
      path: '/extranet/setting',
      component: () => import('../../views/extranet/setting/index.vue')
    }
  ]
}

export default extranetRouter
